<div class="position-relative d-flex flex-column h-100  text-grey" 
  id="addNewJobDialogAbaqus"
  cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary="body"
  [cdkDragDisabled]="!toogleDialog">
  <div class="modal-header jobDialogHeader text-grey" cdkDragHandle>
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Create Fluent Job
  </h4>
  <i
    style="z-index: 1; margin-right: 1rem"
    class="bi bi-dash text-danger"
    [ngClass]="{
      'bi-dash-lg': !toogleDialog,
      'bi-fullscreen': toogleDialog,
      'minmax-dialog': toogleDialog
    }"
    color="warn"
    (click)="toogleDialogMinMax()"
    [title]="toogleDialog ? 'Maximize' : 'Minimize'"
  ></i>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onCancel()"
    title="Close"
  ></i>
</div>
<div class="modal-body jobDialogBody text-grey">
  <form
    name="fluentJobForm"
    [formGroup]="fluentJobForm"
    autocomplete="off"
    spellcheck="false"
  >
    <div class="h-100 d-flex flex-column">
      <div class="flex-grow-1">
        <mat-accordion class="example-headers-align modified-mc-content">
          <mat-expansion-panel
            class="modified-mc-content"
            [expanded]="step === 0"
            (opened)="setStep(0)"
          >
            <mat-expansion-panel-header>
              <mat-panel-title> Job and Application Settings </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field style="width: 48%">
              <mat-label>Job name prefix (Optional)</mat-label>
              <input
                matInput
                maxlength="36"
                placeholder="Job name prefix (Optional)"
                formControlName="fluent_jobNamePrefix"
                matTooltip="Add a unique identifier that will be prefixed with job name. Only alphabets, numbers, '_', '-' , '.' , '@' allowed"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                class="matAutoCompJob"
                autoActiveFirstOption
                #auto="matAutocomplete"
              >
                <mat-option
                  class="matOptionJob"
                  *ngFor="let option of filteredOptions | async"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="fluentJobForm.get('fluent_jobNamePrefix').errors"
                >Name Entered is not Valid.</mat-error
              >
            </mat-form-field>

            <mat-form-field style="width: 48%; margin-left: 4%">
              <mat-label>Standard output file (Optional)</mat-label>
              <input
                matInput
                maxlength="20"
                placeholder="Standard output file (Optional)"
                matTooltip="Standard output and standard errors will be logged in this file. Only alphabets, numbers, '_', '-' , '.' allowed"
                formControlName="fluent_standardOutputFile"
              />
              <mat-error
                *ngIf="fluentJobForm.get('fluent_standardOutputFile').invalid"
                >Name Entered is not Valid.</mat-error
              >
            </mat-form-field>

            <mat-form-field style="width: 48%" [floatLabel]="useFixedNoOfCores ? 'always' : 'auto'">
              <mat-label>Number of Cores* (Max)</mat-label>
              <mat-select
                *ngIf="useFixedNoOfCores"
                formControlName="fluent_numberOfCoresMax"
                required
                [(ngModel)]="maximumCores"
                (ngModelChange)="checkMaxCores()"
              >
                <mat-option
                  *ngFor="let staticCore of staticCores"
                  [value]="staticCore"
                >
                  {{ staticCore }}
                </mat-option>
              </mat-select>
              <input
                matInput
                type="number"
                min="1"
                *ngIf="!useFixedNoOfCores"
                placeholder="Number of Cores (Max)"
                formControlName="fluent_numberOfCoresMax"
                matTooltip="Add number of cores on which job should run. Maximum cores are required, Minimum cores are optional. If given Max cores are not available then given Min cores will be used for job. If those are also not available, job will be kept in queue."
                matTooltipClass="example-tooltip-red"
                [(ngModel)]="maximumCores"
                (ngModelChange)="checkMaxCores()"
                (mousewheel)="$event.preventDefault()"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_numberOfCoresMax').touched &&
                  fluentJobForm.get('fluent_numberOfCoresMax').errors?.required
                "
                >Enter Value of Maximum No. of Cores.</mat-error
              >
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_numberOfCoresMax').touched &&
                  fluentJobForm.get('fluent_numberOfCoresMax').errors?.min
                "
              >
                Value of Maximum no. of Cores should not be in negative.
              </mat-error>
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_numberOfCoresMax').touched &&
                  fluentJobForm.get('fluent_numberOfCoresMax').errors?.max
                "
              >
                Value of Maximum no. of Cores exceeds total no. of cores
                available ({{maximumCoresAllowed}}).
              </mat-error>
            </mat-form-field>

            <mat-form-field class="d-none" style="width: 48%; margin-left: 4%">
              <mat-label>Number of Cores (Min)</mat-label>
              <mat-select
                *ngIf="useFixedNoOfCores"
                formControlName="fluent_numberOfCoresMin"
                required
                [(ngModel)]="minimumCores"
                (ngModelChange)="checkMinCores()"
              >
                <mat-option
                  *ngFor="let staticCore of staticCores"
                  [value]="staticCore"
                >
                  {{ staticCore }}
                </mat-option>
              </mat-select>
              <input
                matInput
                type="number"
                min="1"
                *ngIf="!useFixedNoOfCores"
                placeholder="Number of Cores (Min)"
                matTooltip="Add number of cores on which job should run. Maximum cores are required, Minimum cores are optional. If given Max cores are not available then given Min cores will be used for job. If those are also not available, job will be kept in queue."
                formControlName="fluent_numberOfCoresMin"
                [(ngModel)]="minimumCores"
                (ngModelChange)="checkMinCores()"
                (mousewheel)="$event.preventDefault()"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_numberOfCoresMin').touched &&
                  fluentJobForm.get('fluent_numberOfCoresMin').errors?.required
                "
                >Enter Value of Minimum No. of Cores.</mat-error
              >
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_numberOfCoresMin').touched &&
                  fluentJobForm.get('fluent_numberOfCoresMin').errors
                    ?.invalidCore
                "
              >
                Minimum cores should be lesser than or equal to Maximum Cores.
              </mat-error>
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_numberOfCoresMin').touched &&
                  fluentJobForm.get('fluent_numberOfCoresMin').errors?.min
                "
              >
                Value of Minimum no. of Cores should not be in negative.
              </mat-error>
            </mat-form-field>

            <mat-form-field
              appearance="fill"
              style="width: 48%; margin-left: 4%"
              matTooltip="Select Queue"
              matTooltipPosition="above"
            >
              <mat-label>Select Node Group (Queue)</mat-label>
              <mat-select formControlName="fluent_NodeGroup" multiple>
                <mat-option
                  [disabled]="isNodeGroupDisabled(group)"
                  *ngFor="let group of groups"
                  [value]="group"
                >
                  {{ group }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_NodeGroup').touched &&
                  fluentJobForm.get('fluent_NodeGroup').errors
                "
                >Please Select Node Group (Queue).</mat-error
              >
            </mat-form-field>

            <mat-form-field
              appearance="fill"
              style="width: 48%"
              [ngClass]="
                !makeJobTagMandatoryFlag && !customTagName
                  ? 'me-5'
                  : 'margin-left-with-CustomTag'
              "
            >
              <mat-label>Select App Version</mat-label>
              <mat-select formControlName="fluent_versionControl">
                <mat-option *ngFor="let version of versions" [value]="version">
                  {{ version.name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_versionControl').touched &&
                  fluentJobForm.get('fluent_versionControl').errors?.required
                "
                >Please Select Version.</mat-error
              >
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_versionControl').touched &&
                  fluentJobForm.get('fluent_versionControl').errors
                    ?.executeFileNull
                "
                >Execute file unavailable for selected Application
                Version.</mat-error
              >
            </mat-form-field>

            <mat-form-field
              style="width: 48%; margin-left: 4%"
              appearance="fill"
              matTooltip="Enter project name"
              matTooltipPosition="above"
              *ngIf="makeJobTagMandatoryFlag"
            >
              <mat-label>Add Tag</mat-label>
              <input
                type="text"
                placeholder="Enter tag e.g. Project name"
                matInput
                formControlName="fluent_Tag"
                [matAutocomplete]="tag"
              />
              <mat-autocomplete #tag="matAutocomplete">
                <mat-option
                  *ngFor="let tag of filteredTagOptions | async"
                  [value]="tag"
                >
                  {{ tag }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="fluentJobForm.get('fluent_Tag').errors?.required"
                >Please Add Tag</mat-error
              >
            </mat-form-field>

            <mat-form-field
              appearance="fill"
              style="width: 48%"
              [hidden]="!customTagName"
              [ngClass]="
                makeJobTagMandatoryFlag
                  ? 'margin-left-with-CustomTag'
                  : 'margin-left'
              "
            >
              <mat-label>{{ customTagName }}</mat-label>
              <input
                type="text"
                placeholder="{{ customTagName }}"
                matInput
                formControlName="fluent_customTag"
                [matAutocomplete]="autoCustomTag"
              />
              <mat-autocomplete #autoCustomTag="matAutocomplete">
                <mat-option
                  *ngFor="let autoCustomTag of customTagValues"
                  [value]="autoCustomTag"
                >
                  {{ autoCustomTag }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="fluentJobForm.get('fluent_customTag').errors?.required"
              ></mat-error>
            </mat-form-field>

            <div
              *ngIf="formData"
              style="display: flex; flex-wrap: wrap; margin-bottom: 0.5rem"
            >
              <div
                *ngFor="let control of formData.Controls"
                [ngStyle]="{
                  width: control.Type == 'inputFile' ? '100%' : '50%'
                }"
              >
                <div
                  [ngStyle]="{
                    marginLeft: control.Type == 'inputFile' ? '1%' : '2%'
                  }"
                  style="margin-bottom: 1rem"
                >
                  <!-- dropdown -->
                  <mat-form-field
                    *ngIf="control.Type == 'dropdown'"
                    appearance="fill"
                    style="width: 98%"
                  >
                    <mat-label>{{ control.Label }}</mat-label>
                    <mat-select [formControlName]="control.Name">
                      <mat-option
                        *ngFor="let val of control.AddValue"
                        [value]="val"
                      >
                        {{ val }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- checkbox -->
                  <mat-checkbox
                    *ngIf="control.Type == 'checkbox'"
                    [formControlName]="control.Name"
                    class="mt-2"
                    [title]="control.Label"
                    style="display: inline-flex"
                  >
                    {{ control.Label }}
                  </mat-checkbox>

                  <!-- input text -->
                  <mat-form-field
                    style="width: 98%"
                    *ngIf="['textbox'].includes(control.Type)"
                  >
                    <mat-label>{{ control.Label }}</mat-label>
                    <input
                      matInput
                      [placeholder]="control.Label"
                      type="text"
                      [formControlName]="control.Name"
                      [value]="control.Value"
                      [matTooltip]="control.tooltip"
                    />
                    <mat-error *ngIf="fluentJobForm.get(control.Name).invalid">
                      {{ control.ErrorMsg }}
                    </mat-error>
                  </mat-form-field>

                  <!-- upload files -->
                  <mat-form-field
                    *ngIf="control.Type === 'inputFile'"
                    style="
                      width: 48%;
                      margin-top: 0.4rem;
                      background: var(--s-menuHover-color);
                    "
                  >
                    <mat-label>{{ control.Label }}</mat-label>
                    <input
                      readonly
                      matInput
                      [placeholder]="control.Label"
                      [formControlName]="control.Name"
                      (ngModelChange)="updateJobName($event)"
                      matTooltip="Select input file"
                      matTooltipClass="example-tooltip-red"
                    />
                    <mat-error
                      *ngIf="
                        fluentJobForm.get(control.Name).touched &&
                        fluentJobForm.get(control.Name).errors?.required
                      "
                      >{{ control.ErrorMsg }}</mat-error
                    >
                  </mat-form-field>

                  <!-- upload files -->
                  <div
                    *ngIf="control.Type === 'inputFile'"
                    style="display: inline-flex; align-items: center"
                  >
                    <div style="height: 22px; margin-left: 5px; width: 18px">
                      <a
                        title="Remove"
                        style="cursor: pointer"
                        *ngIf="
                          fluentJobForm.get(control.Name).value != null &&
                          fluentJobForm.get(control.Name).value != ''
                        "
                        (click)="removeFile(control.Name)"
                      >
                        <span
                          class="bi bi-x-lg text-danger"
                          aria-hidden="true"
                          style="color: red; font-size: 18px"
                        >
                        </span>
                      </a>
                    </div>
                    <input
                      type="button"
                      value="Use SyncStore"
                      (click)="loadSyncStoreFileTree(control.Name)"
                      id="inputSyncStoreSelectFile"
                      class="uploadBtn"
                      style="font-size: 12px; margin-left: 5px; outline: none"
                    />
                    <input
                      type="file"
                      [name]="control.Name"
                      [id]="control.Name"
                      #workStoreSelect_fluent_journalFile
                      (click)="onFileChange(control.Name)"
                      style="display: none; font-size: 12px; width: 90px"
                      ng2FileSelect
                      (onFileSelected)="startNg2Upload($event, control.Name)"
                      [uploader]="uploader"
                    />
                    <!-- <label class="dynamicUploadBtn" [for]="control.Name"
                      >Upload File</label
                    > -->
                      <button
                      type="button"
                      #lDynaRestartFile
                      class="uploadBtn pull-right"
                      style="margin-left: 5px; outline: none"
                      [for]="control.Name"
                      (click)="workStoreSelect_fluent_journalFile.click()"
                    >
                      <span class="bi bi-cloud-arrow-up-fill"></span>
                      Upload File
                    </button>
                    <p
                      *ngIf="
                        jobInputIds[control.Name] != null &&
                        cloudType == 'On-Premise'
                      "
                      style="margin: 0 0 0 15px !important"
                      class="uploadPercentage"
                    >
                      {{ jobInputIds[control.Name] === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + jobInputIds[control.Name] + '%' }}
                    </p>
                    <p
                      *ngIf="
                        jobInputIds[control.Name] != null &&
                        cloudType != 'On-Premise'
                      "
                      style="margin: 0 0 0 15px !important"
                      class="uploadPercentage"
                    >
                      {{ jobInputIds[control.Name] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h3>File Settings</h3>

            <mat-checkbox
              formControlName="fluent_journalCheck"
              class="well well-sm"
              style="width: 48%; display: inline-flex"
              (change)="useJournalCheck($event)"
            >
              Use existing journal (.jou) file
            </mat-checkbox>

            <br />

            <mat-form-field
              style="width: 48%; background: var(--s-menuHover-color)"
            >
              <mat-label>Journal File</mat-label>
              <input
                readonly
                matInput
                placeholder="Journal File"
                formControlName="fluent_journalFile"
                matTooltip="Select journal file"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_journalFile').touched &&
                  (fluentJobForm.get('fluent_journalFile').errors?.required ||
                    fluentJobForm.get('fluent_journalFile').errors
                      ?.uploadFailed)
                "
                >Enter Journal File.</mat-error
              >
            </mat-form-field>

            <div style="display: inline-flex; align-items: center">
              <div style="height: 22px; margin-left: 5px; width: 18px">
                <a
                  title="Remove"
                  style="cursor: pointer"
                  (click)="removeFile('fluent_journalFile')"
                  *ngIf="fluentJobForm.get('fluent_journalFile').value != null"
                >
                  <span
                    class="bi bi-x-lg text-danger"
                    aria-hidden="true"
                    style="color: red; font-size: 18px"
                  >
                  </span>
                </a>
              </div>
              <input
                type="button"
                value="Use SyncStore"
                (click)="loadSyncStoreFileTree('fluent_journalFile')"
                #syncStoreSelect_fluent_journalFile
                class="uploadBtn"
                style="font-size: 12px; margin-left: 5px; outline: none"
                [disabled]="
                  fluentJobForm.get('fluent_journalFile').disabled ||
                  fluentJobForm.get('fluent_journalFile').value != null
                "
              />
              <input
                type="file"
                #workStoreSelect_fluent_journalFile
                (click)="onFileChange('workStoreSelect_fluent_journalFile')"
                style="display: none; font-size: 12px; width: 90px"
                (onFileSelected)="startNg2Upload($event, 'fluent_journalFile')"
                ng2FileSelect
                [uploader]="uploader"
              />
              <button
                type="button"
                title="Select and upload files to working directory"
                class="uploadBtn pull-right"
                style="margin-left: 5px; outline: none"
                (click)="workStoreSelect_fluent_journalFile.click()"
                [disabled]="
                  fluentJobForm.get('fluent_journalFile').disabled ||
                  fluentJobForm.get('fluent_journalFile').value != null
                "
              >
                <span class="bi bi-cloud-arrow-up-fill"></span>
                Upload File
              </button>
              <p
                *ngIf="
                  jobInputIds['fluent_journalFile'] != null &&
                  cloudType == 'On-Premise'
                "
                style="margin: 0 0 0 15px !important"
                class="uploadPercentage"
              >
                {{ jobInputIds["fluent_journalFile"] === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + jobInputIds["fluent_journalFile"] + '%' }}
              </p>
              <p
                *ngIf="
                  jobInputIds['fluent_journalFile'] != null &&
                  cloudType != 'On-Premise'
                "
                style="margin: 0 0 0 15px !important"
                class="uploadPercentage"
              >
                {{ jobInputIds["fluent_journalFile"] }}&#125;
              </p>
            </div>

            <mat-form-field
              style="width: 48%; background: var(--s-menuHover-color)"
            >
              <mat-label>Input Case File</mat-label>
              <input
                readonly
                matInput
                placeholder="Input Case File"
                (ngModelChange)="updateJobName($event)"
                formControlName="fluent_inputCaseFile"
                matTooltip="Select input case (.cas/.cas.gz) file name."
                matTooltipClass="example-tooltip-red"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_inputCaseFile').touched &&
                  fluentJobForm.get('fluent_inputCaseFile').errors?.required
                "
                >Enter Input Case File.</mat-error
              >
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_inputCaseFile').touched &&
                  fluentJobForm.get('fluent_inputCaseFile').errors?.uploadFailed
                "
                >Input Case File Required.</mat-error
              >
            </mat-form-field>

            <div style="display: inline-flex; align-items: center">
              <div style="height: 22px; margin-left: 5px; width: 18px">
                <a
                  title="Remove"
                  style="cursor: pointer"
                  *ngIf="
                    fluentJobForm.get('fluent_inputCaseFile').value != null
                  "
                  (click)="removeFile('fluent_inputCaseFile')"
                >
                  <span
                    class="bi bi-x-lg text-danger"
                    aria-hidden="true"
                    style="color: red; font-size: 18px"
                  >
                  </span>
                </a>
              </div>
              <input
                type="button"
                value="Use SyncStore"
                (click)="loadSyncStoreFileTree('fluent_inputCaseFile')"
                #syncStoreSelect_fluent_inputCaseFile
                class="uploadBtn"
                style="font-size: 12px; margin-left: 5px; outline: none"
                [disabled]="
                  fluentJobForm.get('fluent_inputCaseFile').value != null
                "
              />
              <input
                type="file"
                #workStoreSelect_fluent_inputCaseFile
                (click)="onFileChange('workStoreSelect_fluent_inputCaseFile')"
                style="display: none; font-size: 12px; width: 90px"
                (onFileSelected)="
                  startNg2Upload($event, 'fluent_inputCaseFile')
                "
                ng2FileSelect
                [uploader]="uploader"
              />
              <button
                type="button"
                title="Select and upload files to working directory"
                class="uploadBtn pull-right"
                style="margin-left: 5px; outline: none"
                (click)="workStoreSelect_fluent_inputCaseFile.click()"
                [disabled]="
                  fluentJobForm.get('fluent_inputCaseFile').value != null
                "
              >
                <span class="bi bi-cloud-arrow-up-fill"></span>
                Upload File
              </button>
              <p
                *ngIf="
                  jobInputIds['fluent_inputCaseFile'] != null &&
                  cloudType == 'On-Premise'
                "
                style="margin: 0 0 0 15px !important"
                class="uploadPercentage"
              >
                {{ jobInputIds["fluent_inputCaseFile"] === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + jobInputIds["fluent_inputCaseFile"] + '%' }}
              </p>
              <p
                *ngIf="
                  jobInputIds['fluent_inputCaseFile'] != null &&
                  cloudType != 'On-Premise'
                "
                style="margin: 0 0 0 15px !important"
                class="uploadPercentage"
              >
                {{ jobInputIds["fluent_inputCaseFile"] }}
              </p>
            </div>

            <mat-form-field
              style="width: 48%; background: var(--s-menuHover-color)"
            >
              <mat-label>Input Data File</mat-label>
              <input
                readonly
                matInput
                placeholder="Input Data File"
                formControlName="fluent_inputDataFile"
                matTooltip="Select input data (.dat/.dat.gz) file name."
                matTooltipClass="example-tooltip-red"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_inputDataFile').touched &&
                  fluentJobForm.get('fluent_inputDataFile').errors?.required
                "
                >Enter Input Data File.</mat-error
              >
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_inputDataFile').touched &&
                  fluentJobForm.get('fluent_inputDataFile').errors?.uploadFailed
                "
                >Input Data File Required.</mat-error
              >
            </mat-form-field>

            <div style="display: inline-flex; align-items: center">
              <div style="height: 22px; margin-left: 5px; width: 18px">
                <a
                  title="Remove"
                  style="cursor: pointer"
                  *ngIf="
                    fluentJobForm.get('fluent_inputDataFile').value != null
                  "
                  (click)="removeFile('fluent_inputDataFile')"
                >
                  <span
                    class="bi bi-x-lg text-danger"
                    aria-hidden="true"
                    style="color: red; font-size: 18px"
                  >
                  </span>
                </a>
              </div>
              <input
                type="button"
                value="Use SyncStore"
                (click)="loadSyncStoreFileTree('fluent_inputDataFile')"
                #syncStoreSelect_fluent_inputDataFile
                class="uploadBtn"
                style="font-size: 12px; margin-left: 5px; outline: none"
                [disabled]="
                  fluentJobForm.get('fluent_inputDataFile').value != null
                "
              />
              <input
                type="file"
                #workStoreSelect_fluent_inputDataFile
                (click)="onFileChange('workStoreSelect_fluent_inputDataFile')"
                style="display: none; font-size: 12px; width: 90px"
                (onFileSelected)="
                  startNg2Upload($event, 'fluent_inputDataFile')
                "
                ng2FileSelect
                [uploader]="uploader"
              />
              <button
                type="button"
                title="Select and upload files to working directory"
                class="uploadBtn pull-right"
                style="margin-left: 5px; outline: none"
                (click)="workStoreSelect_fluent_inputDataFile.click()"
                [disabled]="
                  fluentJobForm.get('fluent_inputDataFile').value != null
                "
              >
                <span class="bi bi-cloud-arrow-up-fill"></span>
                Upload File
              </button>
              <p
                *ngIf="
                  jobInputIds['fluent_inputDataFile'] != null &&
                  cloudType == 'On-Premise'
                "
                style="margin: 0 0 0 15px !important"
                class="uploadPercentage"
              >
                {{ jobInputIds["fluent_inputDataFile"] === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + jobInputIds["fluent_inputDataFile"] + '%' }}
              </p>
              <p
                *ngIf="
                  jobInputIds['fluent_inputDataFile'] != null &&
                  cloudType != 'On-Premise'
                "
                style="margin: 0 0 0 15px !important"
                class="uploadPercentage"
              >
                {{ jobInputIds["fluent_inputDataFile"] }}
              </p>
            </div>

            <mat-form-field style="width: 48%">
              <mat-label>Output Case File</mat-label>
              <input
                matInput
                placeholder="Output Case File"
                formControlName="fluent_OutputCaseFile"
                matTooltip="Enter output case (.cas/.cas.gz) file name."
                matTooltipClass="example-tooltip-red"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_OutputCaseFile').touched &&
                  fluentJobForm.get('fluent_OutputCaseFile').errors
                "
                >Enter Output Data File.</mat-error
              >
            </mat-form-field>

            <h3>Fluent Settings</h3>

            <div
              style="
                width: 100%;
                display: inline-flex;
                align-items: center;
                height: 30px;
              "
            >
              <section
                style="
                  width: 29%;
                  display: inline-flex;
                  border-right: 1px solid;
                "
              >
                <b>Dimension:</b>
                <mat-radio-group formControlName="fluent_Dimension">
                  <mat-radio-button value="2D" style="margin: 0px 10px"
                    >2D</mat-radio-button
                  >
                  <mat-radio-button value="3D">3D</mat-radio-button>
                </mat-radio-group>
              </section>

              <section
                style="
                  width: 32%;
                  display: inline-flex;
                  border-right: 1px solid;
                  margin-left: 1%;
                "
              >
                <b>Precision:</b>
                <mat-radio-group formControlName="fluent_Precision">
                  <mat-radio-button value="Single" style="margin: 0px 10px"
                    >Single</mat-radio-button
                  >
                  <mat-radio-button value="Dual">Dual</mat-radio-button>
                </mat-radio-group>
              </section>

              <section
                style="width: 38%; display: inline-flex; margin-left: 1%"
              >
                <b>Simulation:</b>
                <mat-radio-group
                  formControlName="fluent_Simulation"
                  (change)="simulationChange($event)"
                >
                  <mat-radio-button value="Steady" style="margin: 0px 10px"
                    >Steady</mat-radio-button
                  >
                  <mat-radio-button value="Unsteady">Unsteady</mat-radio-button>
                </mat-radio-group>
              </section>
            </div>

            <div style="width: 100%; display: inline-flex">
              <mat-form-field style="width: 29%">
                <mat-label>Iterations</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="Iterations"
                  formControlName="fluent_Iterations"
                  matTooltip="Enter Iterations (numbers only)"
                  matTooltipClass="example-tooltip-red"
                  (mousewheel)="$event.preventDefault()"
                />
                <mat-error
                  *ngIf="
                    fluentJobForm.get('fluent_Iterations').hasError('pattern')
                  "
                >
                  Please enter a valid integer.
                </mat-error>
                <mat-error
                  *ngIf="
                    fluentJobForm.get('fluent_Iterations').touched &&
                    fluentJobForm.get('fluent_Iterations').errors?.pattern
                  "
                >
                  Value of Iterations should not be in negative.
                </mat-error>
              </mat-form-field>

              <mat-form-field style="width: 32%; margin-left: 1%">
                <mat-label>Iterations per Time Step</mat-label>
                <input
                  matInput
                  placeholder="Iterations per Time Step"
                  formControlName="fluent_IterationPerTimeStep"
                  matTooltip="Enter Iterations per Time Step"
                  matTooltipClass="example-tooltip-red"
                />
                <mat-error
                  *ngIf="
                    fluentJobForm.get('fluent_IterationPerTimeStep').touched &&
                    fluentJobForm.get('fluent_IterationPerTimeStep').errors
                  "
                >
                  Required*
                </mat-error>
              </mat-form-field>

              <mat-form-field style="width: 38%; margin-left: 1%">
                <mat-label>Total Time Steps</mat-label>
                <input
                  matInput
                  placeholder="Total Time Steps"
                  formControlName="fluent_TotalTimeSteps"
                  matTooltip="Enter Total Time Steps"
                  matTooltipClass="example-tooltip-red"
                />
                <mat-error
                  *ngIf="
                    fluentJobForm.get('fluent_TotalTimeSteps').touched &&
                    fluentJobForm.get('fluent_TotalTimeSteps').errors
                  "
                >
                  Required*
                </mat-error>
              </mat-form-field>
            </div>

            <div style="margin-top: 1%">
              <table
                id="fluent_inputFileTable"
                class="table table-bordered additionalInputs"
                style="
                  overflow-y: scroll;
                  height: 150px;
                  display: block;
                  background-color: #f5f5f5;
                  padding: 0px;
                "
              >
                <tbody>
                  <tr>
                    <td style="width: 10%">
                      <span>Additional Input Files :</span>
                    </td>
                    <td style="width: 35%; text-align: end">
                      <button
                        type="button"
                        id="btnUploadFile"
                        title="Select and upload files to working directory"
                        class="uploadBtn pull-right"
                        style="outline: none"
                        (click)="openFileEditor()"
                        *ngIf="isHeadNodeLinux"
                      >
                        <span class="bi bi-pencil"></span>
                        New File
                      </button>
                      <input
                        multiple
                        type="file"
                        #fluentBtnWorkStore
                        (click)="onFileChange('fluentBtnWorkStore')"
                        style="display: none; font-size: 12px; width: 90px"
                        (onFileSelected)="startNg2Upload($event, null)"
                        ng2FileSelect
                        [uploader]="uploader"
                      />
                      <input
                        type="button"
                        value="Use SyncStore"
                        (click)="loadSyncStoreFileTree()"
                        id="fluentBtnSyncStore"
                        class="uploadBtn pull-right"
                        style="font-size: 12px; outline: none"
                      />
                      <button
                        type="button"
                        id="btnUploadFile"
                        title="Select and upload files to working directory"
                        class="uploadBtn pull-right"
                        style="outline: none"
                        (click)="fluentBtnWorkStore.click()"
                      >
                        <span class="bi bi-cloud-arrow-up-fill"></span>
                        Upload File(s)
                      </button>
                    </td>
                  </tr>
                  <tr *ngFor="let inputFile of jobAdditionalInputFiles">
                    <td><span>File Name :</span></td>
                    <td>
                      <span title="{{ inputFile.path }}">{{
                        inputFile.name
                      }}</span>
                      <button
                        title="Remove File"
                        type="button"
                        style="margin-left: 5px"
                        (click)="removeItem(inputFile)"
                      >
                        <span
                          class="bi bi-x-lg text-danger"
                          style="color: brown"
                        ></span>
                      </button>
                      <button
                        #editFile
                        title="Edit File"
                        type="button"
                        style="margin-left: 5px"
                        id="edit{{ i }}"
                        (click)="editItem(inputFile)"
                        *ngIf="
                          inputFile.isUploadCompleted &&
                          inputFile.type == 'file' &&
                          isHeadNodeLinux && FileTypes.checkIfText(inputFile.path, env.envVariables.TextFileExtension)
                        "
                      >
                        <span
                          class="bi bi-pencil-square text-danger"
                          style="color: brown"
                        ></span>
                      </button>
                      <span
                        *ngIf="
                          inputFile.value != undefined &&
                          cloudType != 'Microsoft Azure'
                        "
                        class="uploadPercentage"
                        >{{ inputFile.value === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + inputFile.value + '%' }}</span
                      >
                      <span
                        *ngIf="
                          inputFile.value != undefined &&
                          cloudType == 'Microsoft Azure'
                        "
                        class="uploadPercentage"
                        >
                          <ng-container *ngIf="inputFile.isUploadCompleted; else showValue">
                            Upload Completed
                          </ng-container>
                          <ng-template #showValue>
                            {{ inputFile.value }}
                          </ng-template>
                        </span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
            class="modified-mc-content"
            [expanded]="step === 2"
            (opened)="setStep(2)"
          >
            <mat-expansion-panel-header>
              <mat-panel-title> Additional Settings </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field style="width: 48%">
              <mat-label>Start Command (Optional)</mat-label>
              <input
                matInput
                placeholder="Start Command (Optional)"
                matTooltip="Add command that will run before job execution"
                formControlName="fluent_startCommand"
              />
            </mat-form-field>

            <mat-form-field style="width: 48%; margin-left: 4%">
              <mat-label>End Command (Optional)</mat-label>
              <input
                matInput
                placeholder="End Command (Optional)"
                formControlName="fluent_endCommand"
                matTooltip="Add command for post-processing"
              />
            </mat-form-field>

            <mat-form-field
              style="width: 48%"
              matTooltip="Memory Per CPU (Optional In GB). Enter numbers only."
              matTooltipPosition="above"
            >
              <mat-label>Memory Per CPU (Optional In GB)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Memory Per CPU (Optional In GB)"
                formControlName="fluent_memoryPerCpu"
                (mousewheel)="$event.preventDefault()"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_memoryPerCpu').touched &&
                  fluentJobForm.get('fluent_memoryPerCpu').errors?.pattern
                "
              >
                Please enter memory per CPU (in GB) in positive number only, e.g
                1.
              </mat-error>
            </mat-form-field>

            <mat-form-field
              style="width: 48%; margin-left: 4%"
              matTooltip="Wallclock Time (Optional, In Min)"
              matTooltipPosition="above"
            >
              <mat-label>Wallclock Time (Optional, In Min)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Wallclock Time (Optional, In Min)"
                formControlName="fluent_wallclockTime"
                (mousewheel)="$event.preventDefault()"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_wallclockTime').touched &&
                  fluentJobForm.get('fluent_wallclockTime').errors?.pattern
                "
              >
                Please enter Wallclock Time (In Min), e.g 30 or 60 or 90. Enter
                positive numbers only
              </mat-error>
            </mat-form-field>

            <mat-form-field
              style="width: 48%"
              matTooltip="Enter tasks per node."
              matTooltipPosition="above"
            >
              <mat-label>Tasks per node</mat-label>
              <input
                matInput
                type="number"
                min="0"
                placeholder="Tasks per node"
                formControlName="fluent_taskPerNode"
                (mousewheel)="$event.preventDefault()"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_taskPerNode').touched &&
                  fluentJobForm.get('fluent_taskPerNode').errors?.pattern
                "
              >
                Please add tasks per node.
              </mat-error>
            </mat-form-field>
            <mat-form-field
              style="width: 48%; margin-left: 4%"
              matTooltip="If true, job will have exclusive access to the node, else job can share nodes with other jobs."
              matTooltipPosition="above"
            >
              <mat-label>Is Job Exclusive ?</mat-label>
              <mat-select formControlName="fluent_isExclusive" required>
                <mat-option value="0">True</mat-option>
                <mat-option value="1">False</mat-option>
              </mat-select>
            </mat-form-field>
           
            <mat-form-field
              style="width: 48%"
              matTooltip="Enter minimum scratch space (in GB), e.g 1. Enter numbers only."
              matTooltipPosition="above"
            >
              <mat-label>Minimum Scratch Space (Optional, In GB)</mat-label>
              <input
                matInput
                type="number"
                placeholder="Minimum Scratch Space (Optional, In GB)"
                formControlName="fluent_MinScratchSpace"
                (mousewheel)="$event.preventDefault()"
              />
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_MinScratchSpace').touched &&
                  fluentJobForm.get('fluent_MinScratchSpace').errors?.required
                "
                >Please enter minimum scratch space (in GB), e.g 1.</mat-error
              >
            </mat-form-field>

            <mat-form-field
              style="width: 48%; margin-left: 4%"
              appearance="fill"
            >
              <mat-label>Schedule Job Submission (Optional)</mat-label>
              <input
                matInput
                [min]="minDate"
                [max]="maxDate"
                [owlDateTimeTrigger]="dt8"
                [owlDateTime]="dt8"
                formControlName="fluent_ScheduleTime"
              />
              <owl-date-time #dt8></owl-date-time>
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_ScheduleTime').touched &&
                  fluentJobForm.get('fluent_ScheduleTime').errors
                "
                >Please provide correct date and time.</mat-error
              >
            </mat-form-field>

            <mat-form-field
              style="width: 48%"
              appearance="fill"
              matTooltip="Enter project name"
              matTooltipPosition="above"
              *ngIf="!makeJobTagMandatoryFlag"
            >
              <mat-label>Add Tag</mat-label>
              <input
                type="text"
                placeholder="Enter tag e.g. Project name"
                matInput
                formControlName="fluent_Tag"
                [matAutocomplete]="tag"
              />
              <mat-autocomplete #tag="matAutocomplete">
                <mat-option
                  *ngFor="let tag of filteredTagOptions | async"
                  [value]="tag"
                >
                  {{ tag }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="fluentJobForm.get('fluent_Tag').errors?.required"
                >Please Add Tag</mat-error
              >
            </mat-form-field>

            <mat-form-field
              appearance="fill"
              style="width: 48%"
              [ngClass]="
                !makeJobTagMandatoryFlag
                  ? 'margin-left'
                  : 'margin-left-with-CustomTag'
              "
            >
              <mat-label>Select Priority</mat-label>
              <mat-select formControlName="fluent_Priority" required>
                <mat-option
                  *ngFor="let priority of priorities"
                  [value]="priority"
                >
                  {{ priority }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  fluentJobForm.get('fluent_Priority').touched &&
                  fluentJobForm.get('fluent_Priority').errors
                "
                >Please Select Priority.</mat-error
              >
            </mat-form-field>

            <mat-form-field
              style="width: 48%"
              matTooltip="Enter path where job data will be copied to after job completion. Default : {{
                outDirMessage
              }}"
              matTooltipPosition="above"
            >
              <mat-label>Job Output Directory</mat-label>
              <input
                matInput
                type="text"
                formControlName="fluent_outputDirectory"
                placeholder="Default : {{ outDirMessage }}"
              />
            </mat-form-field>
            <mat-form-field
              style="width: 48%; margin-left: 4%"
              matTooltip="Enter number of GPU to be used for job. Default : 0"
              matTooltipPosition="above"
            >
              <mat-label>Number of GPU for Job</mat-label>
              <input
                matInput
                type="number"
                formControlName="fluent_NumOfGpuForJob"
                placeholder="Default : 0"
                (mousewheel)="$event.preventDefault()"
              />
            </mat-form-field>

            <mat-form-field
              style="width: 48%"
              matTooltip="Enter number of GPU to be used for per task. Default : 0"
              matTooltipPosition="above"
            >
              <mat-label>Number of GPU per task</mat-label>
              <input
                matInput
                type="number"
                formControlName="fluent_NumOfGpuPerTask"
                placeholder="Default : 0"
                (mousewheel)="$event.preventDefault()"
              />
            </mat-form-field>
            <mat-form-field style="width: 48%; margin-left: 4%"
                           appearance="fill"
                           matTooltip="Select specific nodes to run your job on"
                           matTooltipPosition="above">
             <mat-label>Select Specific Nodes (Optional)</mat-label>
             <mat-select formControlName="fluent_SelectedNodes" multiple (selectionChange)="onFluentNodeSelectionChange($event)">
               <mat-option value="Default">
                 Any 
               </mat-option>
               <mat-option *ngFor="let node of availableNodes" [value]="node.vmName">
                 {{ node.displayName }}
               </mat-option>
             </mat-select>
           </mat-form-field>
            <h3>Dependencies Settings</h3>
            <div class="depend" style="width: 100%">
              <mat-form-field appearance="fill">
                <mat-label>Dependency</mat-label>
                <mat-select formControlName="dependecy">
                  <mat-option value="None">None</mat-option>
                  <mat-option value="after">after</mat-option>
                  <mat-option value="afterany">afterany</mat-option>
                  <mat-option value="afterburstbuffer"
                    >afterburstbuffer</mat-option
                  >
                  <mat-option value="aftercorr">aftercorr</mat-option>
                  <mat-option value="afternotok">afternotok</mat-option>
                  <mat-option value="afterok">afterok</mat-option>
                  <mat-option value="singleton">singleton</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="example-full-width"
                style="margin-left: 5%"
              >
                <mat-label>Input Job Id</mat-label>
                <input type="text" formControlName="jobID" matInput />
                <mat-error
                  *ngIf="
                    fluentJobForm.get('jobID').touched &&
                    fluentJobForm.get('jobID').errors?.required
                  "
                  >Please Enter ':' separated Job ID</mat-error
                >
              </mat-form-field>
            </div>

            <mat-form-field style="width: 100%">
              <mat-label>Additional Parameters (Optional)</mat-label>
              <input
                matInput
                placeholder="Additional Parameters (Optional)"
                formControlName="fluent_additionalParameters"
                matTooltip="Add extra parameters to the execution command"
              />
            </mat-form-field>

            <mat-checkbox
              formControlName="fluent_BackupData"
              style="margin-left: 32%"
            >
              Copy output data of job to Syncstore
            </mat-checkbox>
            <mat-checkbox
              formControlName="fluent_keepWorkStoreData"
              style="margin-left: 32%"
            >
              Keep job data in workstore after job completion
            </mat-checkbox>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <!--<mat-checkbox
    title="Stop all compute nodes after job completion"
    formControlName="fluent_autoShut"
    style="margin-left: 32%"
    >Stop all compute nodes after job completion</mat-checkbox
  >-->

    <div style="display: flex; display: none">
      <mat-checkbox
        formControlName="fluent_jobSchedule"
        class="well well-sm"
        title="Schedule this Job"
        style="padding-left: 32%; display: inline-flex"
      >
        Schedule this job for later,
      </mat-checkbox>
      <input
        matInput
        style="
          margin-left: 2%;
          color: var(--s-primary-color);
          width: 28%;
          border-bottom: 1px solid black;
        "
        formControlName="fluent_customDate"
        placeholder="Job will be executed at the given time."
        type="datetime-local"
        value=""
        [min]="todayDate"
        [max]="maxDate"
      />
    </div>
  </form>
</div>
<div class="modal-footer jobDialogFooter text-grey">
  <div class="w-100" [ngClass]="{ 'd-none': cloudType != 'On-Premise' }">
    <mat-checkbox
      [(ngModel)]="autoSubmitAfterUpload"
      style="margin-left: 32%"
      title="If true, job will be automatically submitted when all the uploads are completed. Note: Make sure all fields are correctly filled, if fields contains error the job will not be submitted."
    >
      Automatically submit job after upload completion.
    </mat-checkbox>
  </div>
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex align-items-center" style="width: 42%">
      <mat-form-field class="flex-grow-1">
        <mat-label>Job template name (Optional)</mat-label>
        <input
          type="text"
          name="jobTemplateName"
          [(ngModel)]="jobTemplateNameValue"
          title="Enter template name to save and use these settings later."
          matInput
        />
      </mat-form-field>
    </div>
    <button
      *ngIf="!isTemplateNameBeingEdited"
      class="default-btn ms-2"
      style="border: 1px solid #0072c6"
      title="Save Template"
      (click)="saveJobTemplate()"
    >
      <span class="bi bi-journal-code"></span> Save
    </button>

    <button
      *ngIf="isTemplateNameBeingEdited"
      class="default-btn ms-2"
      style="border: 1px solid #0072c6"
      title="Update Template"
      (click)="saveJobTemplate()"
    >
      <span class="bi bi-journal-code"></span> Update
    </button>
    <div class="d-flex d-flex justify-content-end w-50">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="onCancel()"
      >
        Close
      </button>
      <button
        type="button"
        class="btn btn-primary ms-2"
        [title]="
          !isHeadnodeActive
            ? 'Job cannot be submitted. Headnode not active.'
            : 'Submit Job'
        "
        [disabled]="
          isUploadActive || isHeadnodeActive == false || autoSubmitAfterUpload
        "
        (click)="onSubmit(fluentJobForm)"
      >
        Submit
      </button>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="resubmitJob"
>
  <p class="pleaseWait text-grey">Please wait ...</p>
</ngx-spinner>
</div>
